import React from 'react'
import { Fragment, useState, useRef } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { AddTemplate } from '../../functions/AddTemplate'


function TemplateModal({
    setShowTempMod,
    showTempMod,
    profile,
}) {

    console.log(profile)

    const [ tempName, setTempName ] = useState('')
    const [ temp, setTemp ] = useState('')

    const cancelButtonRef = useRef()

    return (
        <Transition.Root show={showTempMod} as={Fragment}>
        <Dialog
          as="div"
          static
          className="fixed z-10 inset-0 overflow-y-auto w-full"
          initialFocus={cancelButtonRef}
          open={showTempMod}
          onClose={setShowTempMod}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
  
            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                <div>
                  {/* <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                    <CheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                  </div> */}
                  <div className="mt-1 text-left">
                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                      Add Your Favorite Template
                    </Dialog.Title>
                    <div className="mt-2 mb-4">
                      <p className="text-sm text-gray-600">
                      Paste your favorite template. Do not include "Hey Name" at the top.
                      </p>
                    </div>
                    <div>
                        <p className="font-semibold">Template Name</p>
                        <div>
                            <input 
                                className="my-2 w-full border-2 border-gray-200 rounded-lg p-1 focus:outline-none focus:ring"
                                placeholder="Name of Template"
                                onChange={(e) => setTempName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div>
                    <p className="my-1 font-medium">
                      Template
                    </p>
                    </div>
                    <div>
                    <textarea 
                    placeholder="Paste Template Here"
                    className="border-2 border-gray-200 p-1 rounded-lg w-full focus:ring focus:outline-none h-40"
                    onChange={(e) => setTemp(e.target.value)}
                    />
                    <div className="text-xs float-right">
                        {temp.length}/1000
                    </div>
                    </div>
                  </div>
                </div>
                <div className="flex mt-8">
                    <button
                    className="mt-3 disabled:opacity-50 mr-2 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-indigo-500 text-base text-white font-medium hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                    onClick={() => AddTemplate(
                        setShowTempMod,
                        temp,
                        tempName,
                        profile,
                    )}
                    disabled={temp === "" || tempName === "" || temp.length > 1000 ? true : false}
                    >
                        Add Template
                    </button>
                    <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                    onClick={() => setShowTempMod(false)}
                    ref={cancelButtonRef}
                     >
                        Cancel
                    </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    )
}

export default TemplateModal
